import Rocket from './icons/rocket-gray.svg';
import Chat from './icons/chat-gray.svg';

const IconsPackDesktop = Object.freeze({
  Rocket,
  Chat,
});

export default IconsPackDesktop;
